// Timezone data for different countries, states, and cities
// This provides automatic timezone selection based on location

const timezoneData = {
  'India': {
    default: 'IST',
    states: {
      'Maharashtra': 'IST',
      'Delhi': 'IST',
      'Karnataka': 'IST',
      'Tamil Nadu': 'IST',
      'Telangana': 'IST',
      'Andhra Pradesh': 'IST',
      'Gujarat': 'IST',
      'Rajasthan': 'IST',
      'Madhya Pradesh': 'IST',
      'Uttar Pradesh': 'IST',
      'West Bengal': 'IST',
      'Kerala': 'IST',
      'Punjab': 'IST',
      'Haryana': 'IST',
      'Bihar': 'IST',
      'Odisha': 'IST',
      'Assam': 'IST',
      'Jharkhand': 'IST',
      'Chhattisgarh': 'IST',
      'Uttarakhand': 'IST',
      'Himachal Pradesh': 'IST',
      'Jammu and Kashmir': 'IST',
      'Goa': 'IST',
      'Manipur': 'IST',
      'Meghalaya': 'IST',
      'Tripura': 'IST',
      'Nagaland': 'IST',
      'Arunachal Pradesh': 'IST',
      'Mizoram': 'IST',
      'Sikkim': 'IST'
    }
  },
  'USA': {
    default: 'EST',
    states: {
      'California': 'PST',
      'New York': 'EST',
      'Texas': 'CST',
      'Florida': 'EST',
      'Illinois': 'CST',
      'Pennsylvania': 'EST',
      'Ohio': 'EST',
      'Georgia': 'EST',
      'North Carolina': 'EST',
      'Michigan': 'EST',
      'New Jersey': 'EST',
      'Virginia': 'EST',
      'Washington': 'PST',
      'Arizona': 'MST',
      'Massachusetts': 'EST',
      'Tennessee': 'CST',
      'Indiana': 'EST',
      'Missouri': 'CST',
      'Maryland': 'EST',
      'Colorado': 'MST',
      'Minnesota': 'CST',
      'Wisconsin': 'CST',
      'South Carolina': 'EST',
      'Alabama': 'CST',
      'Louisiana': 'CST',
      'Kentucky': 'EST',
      'Oregon': 'PST',
      'Oklahoma': 'CST',
      'Connecticut': 'EST',
      'Utah': 'MST',
      'Iowa': 'CST',
      'Nevada': 'PST',
      'Arkansas': 'CST',
      'Mississippi': 'CST',
      'Kansas': 'CST',
      'Nebraska': 'CST',
      'Idaho': 'MST',
      'New Mexico': 'MST',
      'West Virginia': 'EST',
      'Hawaii': 'HST',
      'New Hampshire': 'EST',
      'Maine': 'EST',
      'Rhode Island': 'EST',
      'Montana': 'MST',
      'Delaware': 'EST',
      'South Dakota': 'CST',
      'North Dakota': 'CST',
      'Alaska': 'AKST',
      'Vermont': 'EST',
      'Wyoming': 'MST'
    }
  },
  'UK': {
    default: 'GMT',
    states: {
      'England': 'GMT',
      'Scotland': 'GMT',
      'Wales': 'GMT',
      'Northern Ireland': 'GMT'
    }
  },
  'Australia': {
    default: 'AEST',
    states: {
      'New South Wales': 'AEST',
      'Victoria': 'AEST',
      'Queensland': 'AEST_QLD',
      'Western Australia': 'AWST',
      'South Australia': 'ACST',
      'Tasmania': 'AEST',
      'Northern Territory': 'ACST',
      'Australian Capital Territory': 'AEST'
    }
  },
  'Canada': {
    default: 'EST',
    states: {
      'Ontario': 'EST',
      'Quebec': 'EST',
      'British Columbia': 'PST',
      'Alberta': 'MST',
      'Manitoba': 'CST',
      'Saskatchewan': 'CST',
      'Nova Scotia': 'AST',
      'New Brunswick': 'AST',
      'Newfoundland and Labrador': 'NST',
      'Prince Edward Island': 'AST',
      'Northwest Territories': 'MST',
      'Nunavut': 'EST',
      'Yukon': 'PST'
    }
  },
  'New Zealand': {
    default: 'NZST',
    states: {
      'Auckland': 'NZST',
      'Wellington': 'NZST',
      'Canterbury': 'NZST',
      'Waikato': 'NZST',
      'Bay of Plenty': 'NZST',
      'Otago': 'NZST',
      'Northland': 'NZST',
      'Hawke\'s Bay': 'NZST',
      'Manawatu-Wanganui': 'NZST',
      'Tasman': 'NZST',
      'Marlborough': 'NZST',
      'West Coast': 'NZST',
      'Southland': 'NZST'
    }
  },
  'Singapore': {
    default: 'SGT',
    states: {
      'Central Region': 'SGT',
      'East Region': 'SGT',
      'West Region': 'SGT',
      'North Region': 'SGT',
      'North-East Region': 'SGT'
    }
  },
  'Japan': {
    default: 'JST',
    states: {
      'Hokkaido': 'JST',
      'Tokyo': 'JST',
      'Osaka': 'JST',
      'Kanagawa': 'JST',
      'Aichi': 'JST',
      'Fukuoka': 'JST',
      'Kyoto': 'JST',
      'Hyogo': 'JST',
      'Saitama': 'JST',
      'Chiba': 'JST',
      'Hiroshima': 'JST',
      'Okinawa': 'JST'
    }
  },
  'UAE': {
    default: 'GST',
    states: {
      'Abu Dhabi': 'GST',
      'Dubai': 'GST',
      'Sharjah': 'GST',
      'Ajman': 'GST',
      'Ras Al Khaimah': 'GST',
      'Umm Al Quwain': 'GST',
      'Fujairah': 'GST'
    }
  },
  'Germany': {
    default: 'CET',
    states: {
      'Baden-Württemberg': 'CET',
      'Bavaria': 'CET',
      'Berlin': 'CET',
      'Brandenburg': 'CET',
      'Bremen': 'CET',
      'Hamburg': 'CET',
      'Hesse': 'CET',
      'Lower Saxony': 'CET',
      'Mecklenburg-Vorpommern': 'CET',
      'North Rhine-Westphalia': 'CET',
      'Rhineland-Palatinate': 'CET',
      'Saarland': 'CET',
      'Saxony': 'CET',
      'Saxony-Anhalt': 'CET',
      'Schleswig-Holstein': 'CET',
      'Thuringia': 'CET'
    }
  },
  'Indonesia': {
    default: 'WIB',
    states: {
      'Aceh': 'WIB',
      'Bali': 'WITA',
      'Banten': 'WIB',
      'Central Java': 'WIB',
      'East Java': 'WIB',
      'Jakarta': 'WIB',
      'West Java': 'WIB',
      'Yogyakarta': 'WIB',
      'North Sumatra': 'WIB',
      'South Sulawesi': 'WITA',
      'East Kalimantan': 'WITA',
      'Riau': 'WIB',
      'West Sumatra': 'WIB',
      'Papua': 'WIT',
      'Lampung': 'WIB'
    }
  },
  'Kuwait': {
    default: 'GST',
    states: {
      'Capital': 'GST',
      'Hawalli': 'GST',
      'Farwaniya': 'GST',
      'Ahmadi': 'GST',
      'Jahra': 'GST',
      'Mubarak Al-Kabeer': 'GST'
    }
  },
  'Netherlands': {
    default: 'CET',
    states: {
      'Drenthe': 'CET',
      'Flevoland': 'CET',
      'Friesland': 'CET',
      'Gelderland': 'CET',
      'Groningen': 'CET',
      'Limburg': 'CET',
      'North Brabant': 'CET',
      'North Holland': 'CET',
      'Overijssel': 'CET',
      'South Holland': 'CET',
      'Utrecht': 'CET',
      'Zeeland': 'CET'
    }
  },
  'Oman': {
    default: 'GST',
    states: {
      'Muscat': 'GST',
      'Dhofar': 'GST',
      'Musandam': 'GST',
      'Al Buraimi': 'GST',
      'Ad Dakhiliyah': 'GST',
      'Al Batinah North': 'GST',
      'Al Batinah South': 'GST',
      'Ash Sharqiyah North': 'GST',
      'Ash Sharqiyah South': 'GST',
      'Ad Dhahirah': 'GST',
      'Al Wusta': 'GST'
    }
  },
  'Saudi Arabia': {
    default: 'GST',
    states: {
      'Riyadh': 'GST',
      'Makkah': 'GST',
      'Madinah': 'GST',
      'Eastern Province': 'GST',
      'Asir': 'GST',
      'Tabuk': 'GST',
      'Hail': 'GST',
      'Northern Borders': 'GST',
      'Jazan': 'GST',
      'Najran': 'GST',
      'Al Bahah': 'GST',
      'Al Jawf': 'GST',
      'Qassim': 'GST'
    }
  },
  'Sweden': {
    default: 'CET',
    states: {
      'Stockholm': 'CET',
      'Västra Götaland': 'CET',
      'Skåne': 'CET',
      'Östergötland': 'CET',
      'Uppsala': 'CET',
      'Jönköping': 'CET',
      'Halland': 'CET',
      'Örebro': 'CET',
      'Södermanland': 'CET',
      'Dalarna': 'CET',
      'Gävleborg': 'CET',
      'Värmland': 'CET',
      'Norrbotten': 'CET'
    }
  }
};

// Function to get timezone based on country, state, and city
export const getTimezone = (country, state = '', city = '') => {
  if (!country) return 'UTC';
  
  const countryData = timezoneData[country];
  if (!countryData) return 'UTC';
  
  // If state is provided and exists in the mapping
  if (state && countryData.states && countryData.states[state]) {
    return countryData.states[state];
  }
  
  // Return default timezone for the country
  return countryData.default || 'UTC';
};

/**
 * Best-effort country for a timezone abbreviation (for auto-selecting phone country code).
 * Shared zones (e.g. EST) prefer USA over Canada.
 */
const timezoneToCountry = {
  IST: 'India',
  EST: 'USA',
  PST: 'USA',
  CST: 'USA',
  MST: 'USA',
  HST: 'USA',
  AKST: 'USA',
  AST: 'Canada',
  NST: 'Canada',
  GMT: 'UK',
  CET: 'Germany',
  JST: 'Japan',
  SGT: 'Singapore',
  GST: 'UAE',
  WIB: 'Indonesia',
  WITA: 'Indonesia',
  WIT: 'Indonesia',
  AEST: 'Australia',
  AEST_QLD: 'Australia',
  ACST: 'Australia',
  AWST: 'Australia',
  NZST: 'New Zealand',
};

export const getCountryFromTimezone = (timezone) => {
  if (!timezone) return null;
  return timezoneToCountry[timezone] || null;
};

// Function to get all available timezones
// This is now handled by the global timezone utility
export const getAvailableTimezones = () => {
  // Import from global utility to avoid circular dependency
  const { getAvailableTimezones: getGlobalTimezones } = require('../utils/timezoneUtils');
  return getGlobalTimezones().map(tz => tz.value);
};

// Common timezone abbreviations with full names and geographical applicability
export const timezoneNames = {
  'UTC': 'UTC (International - Coordinated Universal Time)',
  'IST': 'IST (India - All states)',
  'EST': 'EST (US Eastern - New York, Florida, Georgia)',
  'PST': 'PST (US Pacific - California, Washington, Oregon)',
  'CST': 'CST (US Central - Texas, Illinois, Missouri)',
  'MST': 'MST (US Mountain - Colorado, Utah, Arizona)',
  'GMT': 'GMT/BST (UK, Ireland — London clock)',
  'CET': 'CET (Central Europe - Germany, France, Italy, Spain)',
  'EET': 'EET (Eastern Europe - Poland, Ukraine, Greece)',
  'JST': 'JST (Japan)',
  'KST': 'KST (South Korea)',
  'CST_ASIA': 'CST (China, Singapore, Philippines, Malaysia)',
  'AEST': 'AEST (Australia Eastern - Sydney, Melbourne)',
  'AEST_QLD': 'Brisbane, Queensland (AEST, UTC+10:00)',
  'AWST': 'AWST (Australia Western - Perth)',
  'ACST': 'ACST (Australia Central - Adelaide)',
  'NZST': 'NZST (New Zealand)',
  'SGT': 'SGT (Singapore)',
  'GST': 'GST (Gulf - UAE, Saudi Arabia, Kuwait, Oman)',
  'WIB': 'WIB (Indonesia Western - Jakarta, Sumatra)',
  'WITA': 'WITA (Indonesia Central - Bali, Sulawesi)',
  'WIT': 'WIT (Indonesia Eastern - Papua, Maluku)',
  'SAST': 'SAST (South Africa)',
  'EAT': 'EAT (East Africa - Kenya, Tanzania)',
  'WAT': 'WAT (West Africa - Nigeria, Ghana)',
  'CAT': 'CAT (Central Africa - Zambia, Zimbabwe)',
  'AST': 'AST (Atlantic Standard Time)',
  'NST': 'NST (Newfoundland Standard Time)',
  'HST': 'HST (Hawaii Standard Time)',
  'AKST': 'AKST (Alaska Standard Time)'
};

export default timezoneData;

